import { baseEnvironment } from './environment.base';

export const environment = {
  ...baseEnvironment,
  env: 'cloudflare',
  api: {
    url: {
      ...baseEnvironment.api.url,
      // apple pay (saferpay)
      getCustomerGeoIpCountryCode: '/components/country_code'
    }
  }
};
